import { eventsTypes } from "../constantes/actionTypes"

const initialState = []

export const events = (state = initialState, action) => {
    switch (action.type) {
        case eventsTypes.GET_ALL_EVENTS_SUCCESS:
            return action.payload
        case eventsTypes.GET_ALL_EVENTS_FAILURE:
            return initialState
        default:
            return state
    }
}